
export default {
  name: 'Breadcrumbs',
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
      required: true,
    },
    category: {
      type: Boolean,
      default: false,
    },
    isAccount: {
      type: Boolean,
      default: false,
    },
  },
  head() {
    return {
      script: [
        {
          json: {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: this.breadcrumbs
              .filter((item) => item.title)
              .map((item, index) => {
                return {
                  '@type': 'ListItem',
                  position: index + 1,
                  item: {
                    '@id':
                      index === this.breadcrumbs.length - 1
                        ? undefined
                        : `https://aurma.kz/${item.slug}`,
                    name: item.title,
                  },
                }
              }),
          },
          type: 'application/ld+json',
        },
      ],
    }
  },

  computed: {
    isMobileApp() {
      return this.$store.getters['rph-main/isMobileApp']
    },
  },
  methods: {
    /* Ссылка чтобы закрыть блок редактирования на странице лк */
    click() {
      this.$store.commit('rph-profile/closeForms')
    },
  },
}
